import { AnalyticsTypes } from '../../utils';
import { ACTION_TYPES, TRACKING_CONSTANTS } from './constants';

export const trackPredictionSelect = (
    gaCategory,
    section = TRACKING_CONSTANTS.DEFAULT_SECTION,
    value,
) => dispatch => {
    const eventDetails = { Selection: value };

    dispatch({
        type: ACTION_TYPES.TRACK_PREDICTION_SELECT,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                category: gaCategory,
                action: 'Select LocationAutocomplete Option',
                label: eventDetails,
                data: {
                    Component: TRACKING_CONSTANTS.LOCATION_PICKER,
                    Element: TRACKING_CONSTANTS.LOCATION_AUTOCOMPLETE,
                    EventDetails: eventDetails,
                    Initiator: TRACKING_CONSTANTS.USER,
                    InteractionType: TRACKING_CONSTANTS.CLICK,
                    Section: section,
                },
            },
        },
    });
};

export const trackTextBoxChange = (
    gaCategory,
    section = TRACKING_CONSTANTS.DEFAULT_SECTION,
    query,
) => dispatch =>
    dispatch({
        type: ACTION_TYPES.TRACK_TEXT_BOX_CHANGE,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                category: gaCategory,
                action: 'Change Address',
                label: query,
                data: {
                    Component: TRACKING_CONSTANTS.LOCATION_PICKER,
                    Element: TRACKING_CONSTANTS.LOCATION_QUERY,
                    EventDetails: { Query: query },
                    Initiator: TRACKING_CONSTANTS.USER,
                    InteractionType: TRACKING_CONSTANTS.TYPE,
                    Section: section,
                },
            },
        },
    });

export const trackTextBoxFocus = (
    gaCategory,
    section = TRACKING_CONSTANTS.DEFAULT_SECTION,
) => dispatch =>
    dispatch({
        type: ACTION_TYPES.TRACK_TEXT_BOX_FOCUS,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                category: gaCategory,
                action: 'Click Address Textbox',
                data: {
                    Component: TRACKING_CONSTANTS.LOCATION_PICKER,
                    Element: TRACKING_CONSTANTS.LOCATION_FIELD,
                    Initiator: TRACKING_CONSTANTS.USER,
                    InteractionType: TRACKING_CONSTANTS.CLICK,
                    Section: section,
                },
            },
        },
    });
